interface EventEmptyStateProps {
  title: string;
}

// Full-page message shown in place of an event (not found, not online yet...)
export const EventEmptyState = ({ title }: EventEmptyStateProps) => {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-2 py-20">
      <img
        src="/images/logos/connect_events_logomark.png"
        alt=""
        className="size-20"
      />
      <h2 className="text-center text-lg font-bold">{title}</h2>
    </div>
  );
};

export default EventEmptyState;
